import styled from 'styled-components';

export const Division = styled.div`
  background-color: ${({ theme }) => theme.new.colors.N300};
  height: ${({ height }) => height || '0.1rem'};
  margin: ${({ margin }) => margin || '1rem 0 2rem 0'};
  width: 100%;
`;
